import gql from 'graphql-tag'

export default gql`
  query listEnterpriseCustomers {
    listEnterpriseCustomers {
      id
      company
      quantity
      createdAt
      startDate
      expirationDate
      payerUser {
        id
        email
        firstname
        lastname
      }
    }
  }
`
